import { IPSeparator, IPText } from 'baseComponents';
import { IPStack } from 'baseComponents/Stack/IPStack';
import GenericModal from 'components/Dialogs/GenericModal';
import ScrollableStackItem from 'components/Utils/ScrollableStackItem';
import { globalStackTokensGapSmall, globalTextStylesBold } from 'globalStyles';
import ResourceLink from 'models/resourceLink';
import { useTranslation } from 'react-i18next';

interface ILinkUnpublishableItemsModalModal {
  isOpen: boolean;
  links?: ResourceLink[];
  onClose: () => void;
}

export const LinkUnpublishableItemsModal = (props: ILinkUnpublishableItemsModalModal) => {
  const { t } = useTranslation(['translation', 'library', 'publication', 'sharepoint', 'lists']);

  const getUnpublishableLinks = () => {
    // linkId > 0 to avoid showing new unsaved links, including temp items for groups
    return props.links?.filter((link) => !link.canPublish() && link.linkId > 0) ?? [];
  };

  //
  // Main render
  //
  return (
    <GenericModal
      isOpen={props.isOpen}
      onClose={props.onClose}
      title={t('publication:Publish.PublicationModal.UnpublishableLinksTitle')}
      subTitle={t('publication:Publish.PublicationModal.UnpublishableLinksSubText')}
      height={500}
      width={700}
      maxWidth={'min(90vw, 700px)'}
      maxHeight={'90vh'}
      minHeight={300}
      minWidth={300}
    >
      <IPStack verticalFill>
        <IPStack.Item>
          <IPSeparator />
        </IPStack.Item>
        <ScrollableStackItem>
          {getUnpublishableLinks().map((link) => (
            <IPStack horizontal tokens={globalStackTokensGapSmall} key={link.linkId}>
              <IPStack.Item styles={{ root: { width: '30%', paddingBottom: 10 } }}>
                <IPText styles={globalTextStylesBold}>{link.linkName}</IPText>
              </IPStack.Item>
              <IPStack.Item styles={{ root: { width: '70%', paddingBottom: 10 } }}>
                <IPText variant="small">{link.getCannotPublishReasonText(t)}</IPText>
              </IPStack.Item>
            </IPStack>
          ))}
        </ScrollableStackItem>
      </IPStack>
    </GenericModal>
  );
};
